import Swal from 'sweetalert2';

/**
 * Toast utility for showing non-intrusive notifications
 *
 * Usage:
 * Toast.fire({
 *   icon: 'success',
 *   title: 'Your message here'
 * });
 *
 * Icons: 'success', 'error', 'warning', 'info', 'question'
 */
export const Toast = Swal.mixin({
  toast: true,
  position: 'bottom-start',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

/**
 * Convenience methods for common toast types
 */
export const showSuccessToast = (title, text = '') => {
  Toast.fire({
    icon: 'success',
    title,
    text,
  });
};

export const showErrorToast = (title, text = '') => {
  Toast.fire({
    icon: 'error',
    title,
    text,
  });
};

export const showWarningToast = (title, text = '') => {
  Toast.fire({
    icon: 'warning',
    title,
    text,
  });
};

export const showInfoToast = (title, text = '') => {
  Toast.fire({
    icon: 'info',
    title,
    text,
  });
};

export default Toast;
